import { Carousel } from '@/components/Carousel';

export const Cases = () => {
  return (
    <section className="section-container pb-20">
      <div className="flex flex-col gap-8 md:gap-[60px]">
        <div className="section-title">
          <div className="section-title-prefix">OUR</div>
          <div className="section-title-main">cases</div>
        </div>
        <div className="w-full overflow-hidden">
          <Carousel />
        </div>
      </div>
    </section>
  );
};
